import type { ReactNode } from 'react';
import { Icono } from './Icono';
import './eleccion.css';

/**
 * Casilla de confirmación de las ventanas (2.5 «Confirmo que son la misma persona», 2.7 «… sabe que se cancelan y está de
 * acuerdo»): cuadro de 24 con borde `--rv-rule-strong`; marcada, roja con el check blanco. La fila entera es el botón
 * (zona de 44), con `role="checkbox"`.
 */
export function Casilla({ marcada, onCambio, children, bloqueada = false }: { marcada: boolean; onCambio: (marcada: boolean) => void; children: ReactNode; bloqueada?: boolean }) {
    return (
        <button
            type="button"
            role="checkbox"
            aria-checked={marcada}
            aria-disabled={bloqueada ? true : undefined}
            className={`rv-casilla${marcada ? ' rv-casilla--on' : ''}`}
            onClick={() => {
                if (!bloqueada) {
                    onCambio(!marcada);
                }
            }}
        >
            <span className="rv-casilla__cuadro" aria-hidden="true">
                <Icono nombre="check" />
            </span>
            <span className="rv-casilla__texto">{children}</span>
        </button>
    );
}
